export const TESTIDS = {
  header: {
    logo: 'header-logo',
    navHome: 'header-nav-home',
    navAbout: 'header-nav-about',
    navBook: 'header-nav-book',
    navResources: 'header-nav-resources',
    navContact: 'header-nav-contact',
    cta: 'header-cta-buy',
    mobileToggle: 'header-mobile-toggle',
  },
  hero: {
    section: 'hero-section',
    buyBtn: 'hero-buy-button',
    meetBtn: 'hero-meet-button',
    bookImage: 'hero-book-image',
  },
  about: { section: 'about-section' },
  book: {
    section: 'featured-book-section',
    buyBookbaby: 'book-buy-bookbaby',
    buyAmazon: 'book-buy-amazon',
  },
  resources: { section: 'resources-section' },
  newsletter: {
    section: 'newsletter-section',
    emailInput: 'newsletter-email-input',
    nameInput: 'newsletter-name-input',
    submitBtn: 'newsletter-submit-button',
    success: 'newsletter-success',
  },
  contact: {
    section: 'contact-section',
    nameInput: 'contact-name-input',
    emailInput: 'contact-email-input',
    typeSelect: 'contact-type-select',
    messageInput: 'contact-message-input',
    submitBtn: 'contact-submit-button',
    success: 'contact-success',
  },
  footer: {
    section: 'footer-section',
    instagram: 'footer-instagram',
    facebook: 'footer-facebook',
  },
};
